import PlatformGrid from "~src/components/platformGrid";
import * as React from 'react';
export default {
  PlatformGrid,
  React
};